<template>
  <div class="page-wrapper bg">
    <div class="title">
      <div>{{ $t('navigation.onlineMall2') }}<span v-if="language !== 'en-US'">ONLINE SHOPPING MALL</span></div>
    </div>
    <div class="content">
      <div class="images">
        <img class="image" src="@images/bg/om_outer_ring.gif" alt="" />
        <img class="image-inter" src="@images/mobile/mall/om_inter_ring.png" alt="" />
        <div class="mall-entry tianmao">
          <div class="entry-text">天猫商城入口</div>
          <img src="@images/mobile/mall/arrow_t.png" class="arrow arrow-up" />
          <img
            src="@images/mobile/mall/om_qr_tianmao.png"
            class="icon"
            alt="天猫"
            @click="onClickJump('https://guangyangsp.tmall.com/')"
          />
        </div>
        <div class="mall-entry jingdong">
          <div class="entry-text">京东商城入口</div>
          <img src="@images/mobile/mall/arrow_b.png" class="arrow arrow-up" />
          <img
            src="@images/mobile/mall/om_qr_jingdong.png"
            class="icon"
            alt="京东"
            @click="onClickJump('https://mall.jd.com/index-1000502548.html')"
          />
        </div>
        <div class="mall-entry xiaochengxu">
          <img
            src="@images/mobile/mall/om_xiaochengxu.png"
            class="icon"
            alt="小程序"
            @click="showQR('xiaochengxu', $event)"
          />
          <img src="@images/mobile/mall/arrow_b.png" class="arrow arrow-up" />
          <div class="entry-text">微信小店入口</div>
        </div>
        <div class="mall-entry pdd">
          <img src="@images/mobile/mall/om_pdd.png" class="icon" alt="拼多多" @click="showQR('pdd', $event)" />
          <img src="@images/mobile/mall/arrow_b.png" class="arrow arrow-up" />
          <div class="entry-text">拼多多商城入口</div>
        </div>
        <div class="mall-entry douyin">
          <img src="@images/mobile/mall/om_douyin.png" class="icon" alt="小程序" @click="showQR('douyin', $event)" />
          <img src="@images/mobile/mall/arrow_b.png" class="arrow arrow-up" />
          <div class="entry-text">抖音商店入口</div>
        </div>
        <div v-if="showQrCode" class="qr-popup" ref="qrPopup">
          <div class="qr-content">
            <img :src="qrImageSrc" alt="二维码" class="qr-image" />
            <span class="close-btn" @click="hideQR">×</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showQrCode: false,
      qrImageSrc: '',
      language: localStorage.getItem('Language')
    }
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {
    onClickJump(url) {
      window.open(url, '_blank')
    },
    showQR(type, event) {
      this.showQrCode = false
      const imageMap = {
        tianmao: require('@images/mobile/mall/om_qr_tianmao.png'),
        jingdong: require('@images/mobile/mall/om_qr_jingdong.png'),
        xiaochengxu: require('@images/mobile/mall/om_qr_xiaochengxu.png'),
        douyin: require('@images/mobile/mall/om_qr_douyin.png'),
        pdd: require('@images/mobile/mall/om_qr_pdd.png')
      }

      this.qrImageSrc = imageMap[type] || ''
      this.showQrCode = true
      this.$nextTick(() => {
        const popup = this.$refs.qrPopup
        if (!popup) return
        // const popupRect = popup.getBoundingClientRect()
        if (type === 'xiaochengxu') {
          popup.style.left = `-6.5vw`
          popup.style.bottom = `13.6vh`
        } else if (type === 'douyin') {
          popup.style.left = `60.5vw`
          popup.style.bottom = `13.6vh`
        } else if (type === 'pdd') {
          popup.style.left = `25.6vw`
          popup.style.bottom = `4.5vh`
        }
      })
    },
    hideQR() {
      this.showQrCode = false
    }
  }
}
</script>
<style scoped lang='scss'>
@import '../style.scss';
.bg {
  background: url('~@images/mobile/bg/mall_bg.jpg') no-repeat;
  background-size: 100% 100%;
}
.content {
  display: flex;
  justify-content: center;
  .images {
    position: relative;
    width: 78.9333vw;
    height: 78.9333vw;
    margin-top: 15.8515vh;
    .image {
      width: 100%;
      height: 100%;
    }
    .mall-entry {
      width: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      z-index: 9;
      img {
        display: block;
      }
      .entry-text {
        font-size: 3.4667vw;
        color: #9d1c21;
      }
      .arrow {
        width: 1.5333vw;
        height: 1.9802vh;
        margin: 0.8487vh 0;
      }
      .icon {
        width: 7.5281vh;
        height: 7.5281vh;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
    }
    .tianmao {
      top: -13vw;
      left: 9.5vw;
    }
    .jingdong {
      right: 9.5vw;
      top: -13vw;
    }
    .xiaochengxu {
      left: -3.9vw;
      bottom: 0.4vh;
    }
    .pdd {
      left: 26.6vw;
      bottom: -8.6vh;
    }
    .douyin {
      right: -4.9vw;
      bottom: 0.4vh;
    }
    .qr-popup {
      position: absolute;
      z-index: 1000;
      width: 26vw;
      height: 26vw;
      bottom: 10vh;
      .qr-content {
        width: 100%;
        height: 100%;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .close-btn {
          position: absolute;
          right: -0.733vw;
          top: -1.133vw;
          width: 4.6667vw;
          height: 4.6667vw;
          background: #fff;
          color: #999;
          font-size: 3.6333vw;
          line-height: 4.6667vw;
          text-align: center;
          border-radius: 50%;
        }
      }
    }
  }
  .image-inter {
    width: 56.5333vw;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>